import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PATHS } from '../shared/constants/paths';
import { DealsPage } from './deals.page';
import { BrowserPageTitle } from '../shared/constants/browser-page-title.enum';

const routes: Routes = [
  {
    path: '',
    component: DealsPage,
    data: { title: BrowserPageTitle.dealsForYou },
  },
  {
    path: PATHS.ALL_DEALS,
    loadChildren: () =>
      import('./pages/all-deals/all-deals.module').then(
        m => m.AllDealsPageModule,
      ),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DealsPageRoutingModule {}
